import { NegotiationOptionAlternativeType } from '../../../generated/graphql';
import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';
import { spaceFactory } from '../../utils/spaceFactory';

const { ExternalNegotiation } = NegotiationOptionAlternativeType;

// TODO: monkeypatch o algo que me permita agregar info al space para saber que vino de esta función
export const getSpaceRappipay: GetSpaceBase = (group, space, context) => {
  const { negBooleans, alternative } = context;
  const {
    isTotalPayment,
  } = negBooleans!;
  const { type: alternativeType } = alternative || {};

  switch (group) {
    case 'NEG_OPTION_EXTERNAL_INSTRUCTIONS': {
      switch (space) {
        case 'title': {
          if (isTotalPayment) {
            if (alternativeType === ExternalNegotiation) {
              return spaceFactory('NEG_OPTION_EXTERNAL_INSTRUCTIONS.title').get();
            }
          }
          break;
        }
        case 'description': {
          if (isTotalPayment) {
            if (alternativeType === ExternalNegotiation) {
              return spaceFactory('NEG_OPTION_EXTERNAL_INSTRUCTIONS.description').get();
            }
          }
          break;
        }
        default: break;
      }
      break;
    }
    default: break;
  }

  return getUndefinedSpace();
};
